import React from 'react';
import BulkUpload from './BulkUpload';

const BulkUploadModal = ({ isOpen, onClose, userId, existingGroups }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Bulk Upload Cards</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <BulkUpload 
          userId={userId} 
          existingGroups={existingGroups} 
          onClose={onClose}
        />
      </div>
    </div>
  );
};

export default BulkUploadModal; 